import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";
import havana from '../../../../../../data/havana';

class Gene extends React.Component {
    constructor(props) {
      super(props);
      this.state = {value: ''};
      this.type = 'variant'
  
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    handleChange(event) {
      this.setState({value: event.target.value});
    }
  
    handleSubmit(event) {
        event.preventDefault();

        const geneCode = this.state.value,
            gene = havana.filter(el => el.gene_name === geneCode)[0],
            chromosome = gene.chromosome,
            position = (gene.stop + gene.start ) / 2

        function getSlotSize (start, stop) {
            if (stop - start < 80000) return 100000
            else return stop - start + 40000
        }

        const slotSize = getSlotSize (gene.start, gene.stop),
            slotLow = position-slotSize/2,
            slotHigh = position+slotSize/2,
            locusLow = gene.start - 2000,
            locusHigh = gene.stop + 2000;

        const newSlot = {
            chr: chromosome,
            low: slotLow,
            high: slotHigh,
        }

        const newLocus = {
            chr: chromosome,
            pos: position,
            low: locusLow,
            high: locusHigh,
        }

        this.props.setSlot(newSlot)
        this.props.setLocus(newLocus);
    }
  
    render() {
      return (
            <div
                className={this.state.value ? 'box boxActive' : 'box'}
                style={{margin: '12px 0 0 0', justifyContent: 'center', width: 'auto'}}
                >
                <form onSubmit={this.handleSubmit}>
                    <input 
                        className="tabInput"
                        type="text" 
                        value={this.state.value} 
                        onChange={this.handleChange} 
                        placeholder={this.props.emptySpace}
                        />
                    <input 
                        id="b_geneSearch"
                        type="submit" 
                        value="Inspect gene" 
                        />
                </form>
            </div>
      );
    }
  }

  export default Gene

